import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useCategoriasStore } from '../../stores/useCategoriasStore';

/** Valor sintético del `<select>` Estado (no es `producto.estado` en BD). */
export const FILTRO_ESTADO_STOCK_BAJO = 'STOCK_BAJO';

/** URL ?stock=agotado|bajo — deep-link desde alertas de inventario. */
export const STOCK_URL_AGOTADO = 'agotado';
export const STOCK_URL_BAJO = 'bajo';

interface FiltrosProductosProps {
  filtros: {
    busqueda: string;
    categoria: string;
    estado: string;
    ordenarPor: string;
    ordenDescendente: boolean;
  };
  onFiltrosChange: (filtros: any) => void;
  /** Ocultar filtro de estado (p. ej. pestaña Archivo). */
  ocultarEstado?: boolean;
}

const selectCls =
  'rounded-full border border-gray-200 bg-white px-3 py-2 text-sm text-[#0B1F4A] shadow-sm focus:outline-none focus:ring-1 focus:ring-[#1A56DB]';

const FiltrosProductos: React.FC<FiltrosProductosProps> = ({ filtros, onFiltrosChange, ocultarEstado = false }) => {
  const { categorias } = useCategoriasStore();
  const categoriasActivas = categorias.filter((c) => c.activa);
  const handleChange = (campo: string, valor: any) => {
    onFiltrosChange({
      ...filtros,
      [campo]: valor
    });
  };

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
      <div className="relative min-w-0 flex-1 sm:max-w-xs">
        <MagnifyingGlassIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" aria-hidden />
        <label htmlFor="busqueda-productos" className="sr-only">
          Buscar
        </label>
        <input
          id="busqueda-productos"
          type="text"
          placeholder="Buscar producto…"
          value={filtros.busqueda}
          onChange={(e) => handleChange('busqueda', e.target.value)}
          className="w-full rounded-full border border-gray-200 bg-white py-2 pl-9 pr-3 text-sm text-[#0B1F4A] placeholder-gray-400 shadow-sm focus:outline-none focus:ring-1 focus:ring-[#1A56DB]"
        />
      </div>

      <label htmlFor="categoria" className="sr-only">
        Categoría
      </label>
      <select
        id="categoria"
        value={filtros.categoria}
        onChange={(e) => handleChange('categoria', e.target.value)}
        className={selectCls}
      >
        <option value="">Todas las categorías</option>
        {categoriasActivas.map((cat) => (
          <option key={cat.id} value={cat.nombre}>
            {cat.icono ? `${cat.icono} ` : ''}
            {cat.nombre}
          </option>
        ))}
      </select>

      {!ocultarEstado && (
        <>
          <label htmlFor="estado" className="sr-only">
            Estado
          </label>
          <select
            id="estado"
            value={filtros.estado}
            onChange={(e) => handleChange('estado', e.target.value)}
            className={selectCls}
          >
            <option value="">Todos los estados</option>
            <option value="ACTIVO">Activo</option>
            <option value="DESCONTINUADO">Descontinuado</option>
            <option value="AGOTADO">Agotado</option>
            <option value={FILTRO_ESTADO_STOCK_BAJO}>Stock bajo</option>
          </select>
        </>
      )}

      <label htmlFor="ordenarPor" className="sr-only">
        Ordenar por
      </label>
      <select
        id="ordenarPor"
        value={filtros.ordenarPor}
        onChange={(e) => handleChange('ordenarPor', e.target.value)}
        className={selectCls}
      >
        <option value="nombre">Nombre</option>
        <option value="precioVenta">Precio</option>
        <option value="stock">Stock</option>
        <option value="ventasUltimos30Dias">Más vendidos</option>
        <option value="fechaCreacion">Más recientes</option>
      </select>
    </div>
  );
};

export default FiltrosProductos;
